export default "__VITE_ASSET__$CLlhN6C__"